/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDigitalBillDto,
  CreatedDigitalBillDto,
  ErrorMessage,
} from '../models';
import {
    CreateDigitalBillDtoFromJSON,
    CreateDigitalBillDtoToJSON,
    CreatedDigitalBillDtoFromJSON,
    CreatedDigitalBillDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models';

export interface CreateDigitalBillRequest {
    locationId: string;
    createDigitalBillDto: CreateDigitalBillDto;
}

/**
 * 
 */
export class CreateDigitalBillControllerApi extends runtime.BaseAPI {

    /**
     */
    async createDigitalBillRaw(requestParameters: CreateDigitalBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatedDigitalBillDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling createDigitalBill.');
        }

        if (requestParameters.createDigitalBillDto === null || requestParameters.createDigitalBillDto === undefined) {
            throw new runtime.RequiredError('createDigitalBillDto','Required parameter requestParameters.createDigitalBillDto was null or undefined when calling createDigitalBill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/locations/{locationId}/digital-bills`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDigitalBillDtoToJSON(requestParameters.createDigitalBillDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatedDigitalBillDtoFromJSON(jsonValue));
    }

    /**
     */
    async createDigitalBill(requestParameters: CreateDigitalBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatedDigitalBillDto> {
        const response = await this.createDigitalBillRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
